import { omit } from 'lodash';
import * as React from 'react';

interface IProps {
  children: React.ReactNode;
  style?: React.CSSProperties;

  to: string;
  subject: string;
  body: string;
}

function objectToQueryParams(obj: any) {
  return Object.keys(obj).map(k => `${k}=${encodeURIComponent(obj[k])}`).join('&');
}

function MailTo(props: IProps) {
  return (
      <a
          style = {props.style}
          href={`mailto:${props.to}?${objectToQueryParams(omit(props, ['children', 'to']))}`}
      >
          {props.children}
      </a>
  );
}

export default MailTo;



// WEBPACK FOOTER //
// ./src/components/MailTo.tsx